export default __webpack_public_path__ + "static/slider3-cf828ee4de9d335c5b5907a2f4bed365.png";